/* @flow */

import { assertObject } from '@e180/util/lib/assert';
import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';

import httpMethodMiddleware from 'src/shared/app/base/middleware/httpMethodMiddleware';
import rootReducer from 'src/shared/app/base/reducer/rootReducer';

import type { State, Store } from 'src/shared/core/type/reduxTypes';

/**
 * Create the redux store
 * @param   {State} preloadedState - Initial state from which to create the store
 * @returns {Store} Store
 *
 * @throws Will throw an exception if parameters are not valid
 */
export function createReduxStore(preloadedState: State): Store {
  assertObject(preloadedState, 'preloadedState');

  return configureStore({
    reducer: rootReducer,
    middleware: [httpMethodMiddleware, ...getDefaultMiddleware()],
    preloadedState,
  });
}
